import { useAtomValue, useSetAtom } from "jotai";
import { Button, Spinner } from "@zapier/design-system";
import { useCallback } from "react";
import { CREATE_NEW_ZAP_BUTTON_TEXT } from "@zapier/canvas-constants";
import {
  createNewZapSetter,
  createNotificationSetter,
  isCreatingZewZapAtom,
} from "@zapier/canvas-state";
import { useEmitResourceCreatedEvents } from "../../hooks/useEmitResourceCreatedEvents";

import useUpdateNode from "../../hooks/useUpdateNode";

type Props = {
  nodeId: string;
};

export function CreateNewZapButton({ nodeId }: Props) {
  const updateNodeAndSave = useUpdateNode();
  const createNotification = useSetAtom(createNotificationSetter);
  const { emitEventOnZapCreation } = useEmitResourceCreatedEvents();
  const isLoading = useAtomValue(isCreatingZewZapAtom);
  const createNewZap = useSetAtom(createNewZapSetter);

  const handleCreateNewZap = useCallback(async () => {
    await createNewZap({
      nodeId,
      updateNodeAndSave,
      createNotification,
      emitEventOnZapCreation,
    });
  }, [
    nodeId,
    createNewZap,
    updateNodeAndSave,
    createNotification,
    emitEventOnZapCreation,
  ]);

  if (isLoading) {
    return <LoadingButton />;
  }

  return (
    <Button
      isFullWidth={true}
      color="primary"
      iconBefore="miscBoltAlt"
      onClick={handleCreateNewZap}
    >
      {CREATE_NEW_ZAP_BUTTON_TEXT}
    </Button>
  );
}

function LoadingButton() {
  return (
    <Button color="primary" disabled={true} isFullWidth={true}>
      <Spinner />
    </Button>
  );
}
